<script setup lang="ts">
/**
 * Invisible loading screen - just the page stock (grain over --background) for a
 * seamless transition into the app (same paper as the shells).
 * Shows while waiting for /process_start API call to complete.
 */
</script>

<template>
  <div class="paper-grain h-screen w-screen bg-background" />
</template>
